type ClassValue = string | false | null | undefined;

/**
 * Склейка классов без зависимости (clsx/tailwind-merge — лишние килобайты
 * в бандле мини-аппа). Конфликты Tailwind-классов не разрешает: там, где
 * вариант может перебивать базовый класс, базовый класс не задаём.
 */
export function cn(...values: ClassValue[]): string {
  let result = '';
  for (const value of values) {
    if (!value) continue;
    result = result ? `${result} ${value}` : value;
  }
  return result;
}
